import { gql } from '@apollo/client'
import { Banner, InformationIcon } from '@farol-ds/react'

import { AiDisclaimer_DocumentFragment } from './__generated__/ai-disclaimer.graphql'

export type AIDisclaimerProps = {
  document: AiDisclaimer_DocumentFragment
}

export function AIDisclaimer({ document }: AIDisclaimerProps) {
  const { isAIGenerated } = document
  if (!isAIGenerated) {
    return null
  }

  return (
    <Banner type="info">
      <Banner.Content>
        <Banner.Title>
          <Banner.Icon>
            <InformationIcon />
          </Banner.Icon>
          Este conteúdo foi criado com auxílio de Inteligência Artificial.
        </Banner.Title>
      </Banner.Content>
    </Banner>
  )
}

AIDisclaimer.fragments = {
  document: gql`
    fragment AIDisclaimer_document on Document {
      isAIGenerated
    }
  `,
}
